export default __webpack_public_path__ + "static/media/profile-tab-arrow.830aad66.svg";